import axios from "axios";

export const feedbackAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/feedback/`,
});
